/*
 * BCPO 的扩展在私有 jQuery 尚未就绪时会反复注入 3.3.1。
 * theme.liquid 在扩展前按 defer 顺序加载同版本，再在这里归还主题的全局 jQuery。
 * CDN 失败时不接管主题的 3.6.0，让扩展保留自己的原生重试/兜底路径。
 */
(function () {
  'use strict';
  var privateJQuery = window.jQuery;
  if (!privateJQuery || !privateJQuery.fn || privateJQuery.fn.jquery !== '3.3.1') return;
  privateJQuery = privateJQuery.noConflict(true);
  window.bcpo = window.bcpo || {};
  if (!window.bcpo.$) window.bcpo.$ = privateJQuery;
})();
